module.exports = __webpack_public_path__ + "img/slide11.44a81616.png";